import { setModalState } from '@/redux/actions/uiActions/modalActions.js';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import { modal } from '@/redux/selectors/uiSelectors';
import { UserProfile } from '@clerk/clerk-react';
import { AnimatePresence, m } from 'framer-motion';
import { useSelector } from 'react-redux';

const transition = { duration: 0.2, type: 'spring', bounce: 0 };

const UserProfileModal = () => {
  const modalState = useSelector(memoizeSelector('modal:userProfile', (state) => modal(state, 'userProfile')));
  const show = modalState?.open;

  return (
    <AnimatePresence>
      {show && (
        <m.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={transition} className={'user-profile-wrapper'}>
          <div className={'user-profile-background'} onClick={() => setModalState('userProfile', { open: false })} />
          <m.div initial={{ scale: 0.8 }} animate={{ scale: 1 }} exit={{ scale: 0.8 }} transition={transition} className={'user-profile-content'}>
            <UserProfile routing={'virtual'} />
          </m.div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default UserProfileModal;
